import React, { FC, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import Icon from 'DesignSystem/Primitives/Icon/Icon';
import { ITableSettings } from 'FeatureModules/DataImport/types/dataImport.types';
import { EAvailableSizes } from 'DesignSystem/types/size.types';
import { InfoTooltip, ThemeTypography, TooltipVariant } from 'DesignSystem';
import FlexBox from 'Components/FlexBox';

export interface IHeaderColumnProps {
  title: string;
  subtitle?: string;
  settings?: ITableSettings;
  isRequired?: boolean;
  tooltip?: {
    helperText: string | ReactNode;
    /** Default INFO */
    variant?: TooltipVariant;
  };
}

const SubHeader = styled('span')(({ theme }) => ({
  color: theme.custom.themeColors.grayScale[60],
}));

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: 'calc(100% - 16px)',
}));

const DragHandle = styled('div')(({ theme }) => ({
  cursor: 'grab',
}));

const HeaderColumn: FC<IHeaderColumnProps> = ({ title, subtitle, isRequired, tooltip }) => {
  return (
    <Container>
      <FlexBox>
        <ThemeTypography variant="BODY_MEDIUM_BOLD" autoOverflow>
          {title} {subtitle && <SubHeader>{subtitle}</SubHeader>} {isRequired && '*'}
        </ThemeTypography>
        {tooltip && (
          <InfoTooltip
            size={EAvailableSizes.SMALL}
            text={tooltip.helperText}
            variant={tooltip.variant}
          />
        )}
      </FlexBox>
      <DragHandle>
        <Icon name="drag-handle" color="gray-60" size="small" />
      </DragHandle>
    </Container>
  );
};

export default HeaderColumn;
